<template lang="pug">
  div
    dados-cartorio(
      @atualizarListaCartorios="atualizarListaCartorios"
    )
      template(slot-scope='scope')
        el-checkbox.input(
          v-model="isInteiroTeor"
          label='Incluir solicitação de "Inteiro Teor"'
          @change="atualizaInteiroTeor"
        )

    dados-oficio-inteiro-teor(
      v-if="isInteiroTeor"
      :dadosAnexos="dadosAnexos"
      v-on="$listeners"
      )

    dados-processo(
      :processo="processo"
    )

</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import DadosCartorio from '@/screens/arrecadacao/cpat/components/oficio/DadosCartorio'
import DadosProcesso from '@/screens/arrecadacao/cpat/components/oficio/DadosProcesso'
import DadosOficioInteiroTeor from '@/screens/arrecadacao/cpat/components/oficio/DadosOficioInteiroTeor'
import { mapActions } from 'vuex'

export default {
  components: {
    Divider,
    DadosCartorio,
    DadosProcesso,
    DadosOficioInteiroTeor
  },

  props: {
    processo: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      isInteiroTeor: false,
      dadosAnexos: []
    }
  },

  created () {
    this.getDadosAnexos().then(response => (this.dadosAnexos = response))
  },

  beforeDestroy () {
    this.$emit('exitInformarDados')
  },

  methods: {
    ...mapActions({
      getDadosAnexos: 'oficioArrecadacao/getDadosAnexos'
    }),

    atualizarListaCartorios (cartorios) {
      this.$emit('atualizarListaCartorios', cartorios)
    },

    atualizaInteiroTeor (value) {
      this.$emit('changeInteiroTeor', value)
      this.$emit('atualizarAnexos', [])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/oficio/InformarDados.vue